import { memo, useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Empty, Flex } from 'antd';

import { Loader } from '@/shared/ui/loader';

import type { CalendarData } from '../../models/types/transformed-calendar-data';
import { TradingPlatformDailyInfoAsDrawer } from '../trading-platform-daily-info-as-drawer/trading-platform-daily-info-as-drawer';
import { TradingPlatformDailyTradesCard } from '../trading-platform-daily-trades-card/trading-platform-daily-trades-card';

import cls from './trading-platform-daily-trades-card-list.module.css';

interface TradingPlatformDailyTradesCardListProps {
    dataSource: Map<DateString, CalendarData>;
    isLoading: boolean;
}

export const TradingPlatformDailyTradesCardList = memo(
    (props: TradingPlatformDailyTradesCardListProps) => {
        const { dataSource, isLoading } = props;

        const { t } = useTranslation('trading-journal');

        const [isOpened, setIsOpened] = useState<boolean>(false);
        const [chosenData, setChosenData] = useState<CalendarData>();

        const onOpen = useCallback((data: CalendarData) => {
            setIsOpened(true);
            setChosenData(data);
        }, []);

        const onClose = useCallback(() => {
            setIsOpened(false);
        }, []);

        if (isLoading) {
            return (
                <Flex
                    align="center"
                    className={cls.spinContainer}
                    justify="center"
                >
                    <Loader />
                </Flex>
            );
        }

        return dataSource.size ? (
            <>
                <Flex
                    gap={8}
                    vertical
                >
                    {Array.from(dataSource.entries()).map(([key, data]) => (
                        <TradingPlatformDailyTradesCard
                            key={key}
                            data={data}
                            onClick={onOpen}
                        />
                    ))}
                </Flex>
                <TradingPlatformDailyInfoAsDrawer
                    data={chosenData}
                    isOpened={isOpened}
                    onClose={onClose}
                />
            </>
        ) : (
            <Empty
                description={t('tradingJournalTradesListEmpty')}
                image={Empty.PRESENTED_IMAGE_SIMPLE}
            />
        );
    },
);

TradingPlatformDailyTradesCardList.displayName =
    'TradingPlatformDailyTradesCardList';
